module.exports = __webpack_public_path__ + "img/station_null.f0ca1444.svg";